export default "/images/vendor/flag-icon-css/flags/4x3/dk.svg?f4e8fc5376a202f1d771ff93fab6b2ea";